import React from 'react';
import classes from './spinner.css'

const spinner=(props)=>{

	let classAdd=classes.Loader;

	if(props.align){
		classAdd= `${classes.Loader} ${classes.Middle} `
	}

	return <div className={classAdd} >Loading...</div>

	}
export default spinner;


// WEBPACK FOOTER //
// ./src/components/UI/spinner/spinnner.jsx